import React from 'react';
import { Search } from 'lucide-react';

/** Ô tìm kiếm + hàng nút lọc theo danh mục. */
const AppFilterBar = ({ searchTerm, onSearchChange, categories, selectedCategory, onCategoryChange }) => (
    <div className="flex flex-col lg:flex-row gap-6 items-center justify-between mb-12">
        <div className="relative w-full lg:w-96">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 dark:text-slate-500" />
            <input
                type="search"
                placeholder="Tìm theo tên, mô tả hoặc thẻ..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                aria-label="Tìm kiếm ứng dụng"
                className="w-full pl-12 pr-4 py-4 bg-white/60 dark:bg-white/[0.05] backdrop-blur-glass border border-white/40 dark:border-white/[0.08] rounded-xl text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:border-primary-500/60 focus:ring-2 focus:ring-primary-500/20 transition-all shadow-sm"
            />
        </div>

        <div className="flex flex-wrap gap-2 justify-center lg:justify-end">
            {categories.map((category) => (
                <button
                    key={category}
                    onClick={() => onCategoryChange(category)}
                    className={`px-4 py-2 rounded-xl font-medium text-sm transition-all ${
                        selectedCategory === category
                            ? 'bg-primary-600 text-white shadow-md shadow-primary-600/25'
                            : 'bg-white/50 dark:bg-white/[0.05] backdrop-blur-sm text-slate-600 dark:text-slate-400 hover:bg-white/70 dark:hover:bg-white/[0.08] hover:text-slate-900 dark:hover:text-white border border-white/40 dark:border-white/[0.08]'
                    }`}
                >
                    {category === 'all' ? 'Tất cả' : category}
                </button>
            ))}
        </div>
    </div>
);

export default AppFilterBar;
